(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dynamic-mixed-collections"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", (event) => {
    let products = document.querySelectorAll( '.featured-collection__wrapper article' );
    
    document.addEventListener( 'scroll' , ( e ) => {

      window_bottom = window.scrollY + window.outerHeight;

      products.forEach( ( product, i ) => {

        if ( product.offsetTop < ( window_bottom * 0.9 ) ) {

          product.style.animationPlayState = 'running';
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
